import React, { useRef } from 'react'
import { Spin } from 'antd'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { A4_LANDSCAPE } from 'src/views/Management/Reports/types'
import { ApplicationState } from 'src/store'
import * as Css from './styles'
import {
  generateCvsReduce,
  generateReportPages,
  getCvsHeader,
  handleDownloadCsv
} from './components/utils'
import { ControlReportRefProps } from './types'
import { Footer, OptionsBar } from '..'

function R14() {
  const {
    reports: {
      reportsResources: {
        R14Data: { data: report, loading: reportLoadings },
        R14Header: { data: header, loading: headerLoading }
      }
    }
  } = useSelector((state: ApplicationState) => ({
    reports: state.reports
  }))

  const { t } = useTranslation()
  const controlReportRef = useRef<ControlReportRefProps>({
    availableSpace: 0,
    nextIndex: 0,
    reportIndex: 0
  })

  if (reportLoadings || headerLoading || !header.length) {
    return <Spin />
  }

  function generateCvs() {
    handleDownloadCsv(
      report.reduce(generateCvsReduce, getCvsHeader(header, t)),
      t
    )
  }

  const pages = generateReportPages(controlReportRef, report, header)

  return (
    <>
      <OptionsBar generateCvs={generateCvs} />
      {pages.map(page => (
        <Css.Page key={page.index} className="print" pageShape={A4_LANDSCAPE}>
          <Css.Content pageShape={A4_LANDSCAPE}>
            {page.content.map(pageItens => (
              <React.Fragment key={pageItens.index}>
                {pageItens.content}
              </React.Fragment>
            ))}
          </Css.Content>
          <Footer pagination={{ x: page.index + 1, y: pages.length }} />
        </Css.Page>
      ))}
    </>
  )
}

export default R14
